import Content from '@/pages/collect/components/content';
import LoginNode from '@/pages/login';
import { notification } from 'antd';
import { Modal, Toast } from 'antd-mobile';
import React, { useEffect, useState } from 'react';
import { getLocale, history } from 'umi';
import { extend } from 'umi-request';

/** Request 网络请求工具 更详细的 api 文档: https://github.com/umijs/umi-request */
const codeMessage: any = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

/** 异常处理程序 */

const errorHandler = (error: { response: Response }): Response => {
  const { response } = error;
  if (response && response.status) {
    const errorText = codeMessage[response.status] || response.statusText;
    const { status, url } = response;

    Toast.offline(`请求错误 ${status}: ${url}`, 3);
  } else if (!response) {
    return response;
  }
  return response;
};

/** 配置request请求时的默认参数 */
const request = extend({
  // prefix: process.env.baseUrl,
  errorHandler, // 默认错误处理
  // credentials: 'include', // 默认请求是否带上cookie
});

// request拦截器, 改变url 或 options.
request.interceptors.request.use((url, options) => {
  return {
    url: url,
    options: { ...options, interceptors: true },
  };
});

request.interceptors.response.use(async (response) => {
  let data;
  if (response.clone().url.includes('log.cmishow')) {
    return;
  } else if (
    response.clone().url.includes('ctmLogin.action') ||
    response.clone().url.includes('userInfo.action') ||
    response.clone().url.includes('payPlay.action')
  ) {
    data = await response.clone();
  } else {
    data = await response.clone().json();
  }

  if (data.code === 1004) {
    // notification.error({
    //   message: 'token失效，请重新登录。',
    Toast.offline(`登錄信息失效請重新登陸`, 3);
    // });
    localStorage.clear(); //清除过期的token
    //@ts-ignore
    history.push({ pathname: '/login' });
    return false;
  }
  return response;
});

export default request;
